module.exports = __webpack_public_path__ + "static/img/banner.c6f6fb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/banner.png
// module id = PlWd
// module chunks = 1